/**
 * ============================================================
 *
 * [koshikami_prime_life]
 * 
 * ============================================================
 */

/* img slick */
$(function () {
    $('#content_area .visual.img ul').each(function () {
        const $slider = $(this);
        if (!$slider.hasClass('slick-initialized')) {
            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                infinite: true,
                speed: 500,
                autoplay: false,
                adaptiveHeight: false
            });
        }
    });
});

/* THE PRIMEのある暮らし Slick  */
$(function () {
    const $lifeSlider = $('#other_area .inner .list');
    
    function initLifeSlider() {
        if (window.matchMedia('(max-width: 768px)').matches) {
            if (!$lifeSlider.hasClass('slick-initialized')) {
                $lifeSlider.slick({
                    centerMode: true,
                    slidesToShow: 1,
                    arrows: false,
                    dots: false,
                    infinite: false,
                    speed: 500,
                    cssEase: 'ease',
                    adaptiveHeight: false
                });
            }
        } else {
            if ($lifeSlider.hasClass('slick-initialized')) {
                $lifeSlider.slick('unslick');
            }
        }
    }
    
    initLifeSlider();

    $(window).on('resize', function () {
        initLifeSlider();
    });
});